import { useEffect, useState } from 'react';
import type { LottieImageProps } from './lottie-types';

export function LottieImage({
  animationData,
  className,
  lottieRef,
}: LottieImageProps) {
  const [LottieView, setLottieView] = useState<React.ReactNode>(null);

  useEffect(() => {
    let isMounted = true;

    // Dynamic import of lottie-react to avoid SSR issues
    import('lottie-react').then((module) => {
      if (!isMounted) return;

      const { useLottie } = module;

      // Create a wrapper component that uses the hook
      const LottieWrapper = () => {
        const { View } = useLottie({
          animationData,
          loop: true,
          lottieRef,
        });
        return View;
      };

      // Render the component
      setLottieView(<LottieWrapper />);
    });

    return () => {
      isMounted = false;
    };
  }, [animationData, lottieRef]);

  return <div className={className}>{LottieView}</div>;
}
